package navigation.settings.general

import com.essntl.core.settings.domain.model.configuration.ConfigurationLogoModel
import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class GeneralViewModel(
    private val configurationRepository: ConfigurationRepository,
    val state: MutableStateFlow<GeneralState> = MutableStateFlow(GeneralState()),
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: GeneralEvent) {
        when (event) {
            is GeneralEvent.GetLogo -> getLogo()
            is GeneralEvent.UpdateLogo -> updateLogo(event)
            is GeneralEvent.DeleteLogo -> deleteLogo()
        }
    }

    private fun getLogo() =
        getData(
            getData = { configurationRepository.getLogo() },
            getState = { state.value.getLogo },
            setState = { newState -> state.update { it.copy(getLogo = newState) } },
        )

    private fun updateLogo(event: GeneralEvent.UpdateLogo) {
        getData(
            getData = {
                configurationRepository.updateLogo(
                    file = event.file,
                    bucketName = "images",
                    folderName = "branding",
                    context = event.context,
                )
            },
            getState = { state.value.getLogo },
            setState = { newState -> state.update { it.copy(getLogo = newState) } },
        )
    }

    private fun deleteLogo() {
        val url = state.value.getLogo.data?.url ?: return

        scope.launch {
            loadingManager.emitLoading(true)
            state.update {
                it.copy(
                    deleting = true,
                )
            }

            configurationRepository
                .deleteLogo(url)
                .onSuccess {
                    loadingManager.emitLoading(false)
                    state.update {
                        it.copy(
                            getLogo = State.success(ConfigurationLogoModel(url = null)),
                            deleting = false,
                        )
                    }
                }.onFailure {
                    loadingManager.emitLoading(false)
                    state.update {
                        it.copy(
                            deleting = false,
                        )
                    }
                }
        }
    }
}